import api from "../api.js";

export interface AvatarUploadResponse {
  success: boolean;
  data: {
    avatarUrl: string;
    thumbnailUrl: string;
    uploadedAt: Date;
    fileSize: number;
  };
}

export interface AvatarUrlsResponse {
  success: boolean;
  data: {
    avatarUrl: string;
    thumbnailUrl: string;
    uploadedAt: Date;
    fileSize: number;
  };
}

/**
 * Upload avatar image
 */
export const uploadAvatar = async (
  file: File,
  cropData?: { x: number; y: number; width: number; height: number },
): Promise<AvatarUploadResponse> => {
  const formData = new FormData();
  formData.append("avatar", file);

  if (cropData) {
    formData.append("cropData", JSON.stringify(cropData));
  }

  const response = await api.post<AvatarUploadResponse>(
    "/users/avatar/upload",
    formData,
  );

  return response.data;
};

/**
 * Delete user's avatar
 */
export const deleteAvatar = async (): Promise<{
  success: boolean;
  message: string;
}> => {
  const response = await api.delete("/users/avatar");
  return response.data;
};

/**
 * Get avatar URLs for a user
 */
export const getAvatarUrls = async (
  userId: string,
): Promise<AvatarUrlsResponse> => {
  const response = await api.get<AvatarUrlsResponse>(`/users/avatar/${userId}`);
  return response.data;
};

export default {
  uploadAvatar,
  deleteAvatar,
  getAvatarUrls,
};
